<div class="footer text-white text-center">
  <div
    class="footer-text d-flex align-items-center justify-content-center mt-200px"
    [ngClass]="isCorporate ? 'bg-primary-corporate' : 'bg-primary'"
  >
    <div class="footer-content pt-3">
      <div class="justify-content-center d-lg-flex align-items-center my-3">
        <div class="d-flex justify-content-center mb-lg-0 mb-4 align-items-center">
          <a href="{{ 'footer.visit.malaysia.url' | translate }}" target="_blank">
            <img class="visit-malaysia mx-3" [src]="'footer/visit-malaysia.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.castore.url' | translate }}" target="_blank">
            <img class="castore mx-3" [src]="'footer/castore.png' | contentAssetImage" draggable="false" />
          </a>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <a href="{{ 'footer.nathaniel.cars.url' | translate }}" target="_blank">
            <img class="ncars mx-lg-3 mx-2" [src]="'footer/nathaniel.png' | contentAssetImage" draggable="false" />
          </a>
          <a class="d-lg-none" href="{{ 'footer.cyber.certified.url' | translate }}" target="_blank">
            <img class="cyber mx-2" [src]="'footer/cyber-certified.png' | contentAssetImage" draggable="false" />
          </a>
          <a href="{{ 'footer.molson.coors.url' | translate }}" target="_blank">
            <img
              class="molson mx-3"
              [src]="'footer/molson-coors.png' | contentAssetImage"
              draggable="false"
              *notInPopulation="[populations.JuniorBluebirds]"
            />
          </a>
          <a class="d-lg-flex d-none" href="{{ 'footer.cyber.certified.url' | translate }}" target="_blank">
            <img class="cyber mx-3" [src]="'footer/cyber-certified.png' | contentAssetImage" draggable="false" />
          </a>
        </div>
      </div>
      <ng-container *ngIf="!isCorporate">
        <img class="mt-4 mb-2 footer-club-logo" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" />
      </ng-container>
      <ng-container *ngIf="isCorporate">
        <img class="mt-4 mb-2 footer-club-logo" [src]="'logos/corporate-logo.png' | contentAssetImage" draggable="false" />
      </ng-container>
      <div
        class="copy-right text-white font-size-14 mt-2 text-center mb-4"
        [innerHTML]="'copy.right' | translate | markdownTranslate"
      ></div>
    </div>
  </div>
</div>
